import { fabric } from 'fabric'

export default {
  isA: function (object) {
    return object.type === 'i-text'
  },

  isEditing: function (object) {
    // ignore object type so this works for notes as well
    return object && object.isEditing
  },

  new: function (pointer, settings) {
    settings.left = pointer.x
    settings.top = pointer.y
    return new fabric.IText('', settings)
  },

  edit: function (text, canvas, callback) {
    canvas.setActiveObject(text)
    this.enterEditing(text)

    text.on('changed', () => {
      // clear text styles that are present if we paste text in as they can't be changed by the user
      text.styles = {}
    })

    text.on('editing:exited', () => {
      if (text.text.length !== 0) {
        text.off('editing:exited')
        text.setCoords()
        canvas.discardActiveObject()
        callback()
      } else {
        canvas.remove(text)
      }
    })
  },

  configureControls: function (text) {
    text.set({
      lockUniScaling: true
    })
  },

  setTextColour: function (text, colour) {
    text.set({ fill: colour })
  },

  enterEditing: function (text) {
    const result = text.enterEditing()

    // fix for issue where you can no longer enter text
    // not clear why this fixes the issue
    if (text.hiddenTextarea) {
      text.hiddenTextarea.style.lineHeight = 'initial'
    }

    return result
  }
}
